"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 20.11.2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converts attributes of SupplierAgreement
 * @author ZSr
 */


var SupplierAgreementConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SupplierAgreementConverter, _DataObjectConverter_);

  function SupplierAgreementConverter() {
    _classCallCheck(this, SupplierAgreementConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SupplierAgreementConverter).apply(this, arguments));
  }

  return SupplierAgreementConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SupplierAgreementConverter = SupplierAgreementConverter;